import { ToggleConfig } from '@ardoq/view-settings';
import { MouseEventHandler, MouseEvent } from 'react';
import { ButtonIcon } from './ButtonIcon';
import { ViewIds } from '@ardoq/api-types';
import { noop } from 'lodash';

interface ToggleProps extends ToggleConfig {
  viewId: ViewIds;
  rightAligned?: boolean;
  onClick?: MouseEventHandler;
}

const NewerToggle = ({
  viewId,
  id,
  isActive,
  label = '',
  iconName,
  popoverText,
  persistent = true,
  isInverted = false,
  isDisabled = false,
  currentValue = isActive,
  onClick,
  onViewSettingsUpdate = noop,
}: ToggleProps) => {
  const toggleSetting = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    const settings = { [id]: isInverted ? currentValue : !currentValue };
    onViewSettingsUpdate(viewId, settings, persistent);
  };

  return (
    <ButtonIcon
      iconName={iconName}
      isActive={isActive}
      onClick={e => (onClick ? onClick(e) : toggleSetting(e))}
      data-tooltip-text={popoverText ? undefined : label}
      isDisabled={isDisabled}
      label={label}
      data-click-id={id}
      popoverText={popoverText}
    />
  );
};

export { NewerToggle };
